import React, { Component } from 'react';
import { func, shape, string, bool } from 'prop-types';
import { connect } from 'react-redux';
import toJS from '~/views/enhancers/toJS';

import actions from '~/state/ducks/author/actions';
import { fetchAuthor } from '~/state/ducks/author/operations';
import { getSelected, isEditing } from '~/state/ducks/author/selectors';
import { getUserData, getUserID } from '~/state/ducks/auth/selectors';

import AuthorSelectorForm from '../components/AuthorSelector';
import Search from '../containers/Search';


class AuthorSelectorContainer extends Component {

    static propTypes = {
        isEditing: bool.isRequired,
        fetchAuthor: func.isRequired,
        setSelected: func.isRequired,
        defaultUserData: shape({
            id: string.isRequired,
            name: string.isRequired,
            logo_url: string.isRequired,
        }).isRequired,
        selected: shape({
            id: string.isRequired,
            name: string.isRequired,
            logo_url: string.isRequired,
        }),
        input: shape({
            value: string.isRequired,
            onChange: func.isRequired,
        }).isRequired,
        meta: shape({
            initial: string,
        }).isRequired,
    };

    componentDidMount() {
        const {
            meta, input, fetchAuthor, setSelected, defaultUserData,
        } = this.props;

        if (meta.initial) {
            fetchAuthor(meta.initial);
        } else {
            setSelected(defaultUserData);
            //input.onChange(defaultUserData.id);  //-> throws function passed to reduxForm must return a promise
            this.setState({ author_id: defaultUserData.id })
        }
    }

    render() {
        const { meta: { initial }, selected, isEditing } = this.props;
        const readOnly = (initial !== undefined);

        if (isEditing) {
            return <Search {...this.props} />;
        } else if (selected) {
            return <AuthorSelectorForm {...this.props} readOnly={readOnly} />;
        }
        return null;
    }
}


const mapStateToProps = state => ({
    selected: getSelected(state),
    isEditing: isEditing(state),
    defaultUserData: getUserData(state),
});

const mapDispatchToProps = {
    fetchAuthor,
    setSelected: actions.set,
    toggleEditMode: actions.editing.toggle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AuthorSelectorContainer);
